export default "__VITE_ASSET__Da7rsd1n__"